import { Button, TableCell, TableRow, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { Company } from '@staffedupusa/shared-components';
import { darkBlue, darkBlue2 } from '@styles/colors';
import dayjs from 'dayjs';
import { FC, useState } from 'react';
import { Link } from 'react-router-dom';


type RowData = {
    email: String;
    name: String;
    num_logins: String;
    last_login: Date;
    id: number
    company: Company;
};
type RockerboxListingRowProps = {
    row: RowData;
};

const RockerboxListingRow: FC<RockerboxListingRowProps> = ({ row }) => {
    const [value, setValue] = useState(row.company.wotc_enabled);

    return (
        <TableRow>
            <TableCell>
                <ToggleButtonGroup
                    value={value}
                    exclusive
                // onChange={(event, newValue) => {
                //     setValue(newValue);
                // }}
                // disabled
                >
                    <ToggleButton sx={{
                        padding: "3px 15px",
                        borderBottomLeftRadius: '5px',
                        borderTopLeftRadius: '5px',
                        backgroundColor: value ? darkBlue2 : 'default',
                        color: value ? 'white' : 'default',
                        '&.Mui-selected': {
                            backgroundColor: darkBlue2,
                            color: 'white',
                        },
                    }}
                        disabled={value}
                        value={true}>On</ToggleButton>
                    <ToggleButton sx={{
                        padding: "3px 15px",
                        borderBottomRightRadius: '5px',
                        borderTopRightRadius: '5px',
                        backgroundColor: !value ? darkBlue2 : 'default',
                        color: !value ? 'white' : 'default',
                        '&.Mui-selected': {
                            backgroundColor: darkBlue2,
                            color: 'white',
                        },
                    }}
                        disabled={!value}
                        value={false}>Off</ToggleButton>
                </ToggleButtonGroup>
            </TableCell>
            <TableCell style={{ textDecoration: 'none' }}>
                <Button
                    variant="text"
                    size="small"
                    sx={{ textDecoration: "underline", color: darkBlue }}
                >
                    <Link to={`/rockerbox/company/${row.id}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                        {row.company.s_name}
                    </Link>
                </Button>
            </TableCell>
            <TableCell>{row.name}</TableCell>
            <TableCell>{row.email}</TableCell>
            <TableCell>
                {row.company.s_city}, {row.company.s_state}
            </TableCell>
            <TableCell>{dayjs(row.last_login).format('MM/DD/YY')}</TableCell>
        </TableRow>
    );
};

export default RockerboxListingRow;
